import React from 'react';

const FPContent = ({ t, o , b }) => {
  const p1 = t("fp.p1");
  const p2 = t("fp.p2");
  const p3 = t("fp.p3");
  const p4 = t("fp.pChina");

  return (
    <>
      {o === "China" || b === "1405" && <p>{p4}</p>}
      <p>{p1}</p>
      <p>{p2}</p>
      <p dangerouslySetInnerHTML={{ __html: p3 }} />
    </>
  );
};

const FillPower = (props) => {
  const { t, vFP, sFP, changeWord , o} = props;

  const label = t("fp.label");
  const verifiedLabel = t("verifiedAt").split(" ")[0];
  const statedLabel = t("stated");

  return (
    <div className="content-ac fp hide">
      <input
        className="ac-input top"
        id="ac-3afd"
        name="ac-3afd"
        data-id="2400"
        data-slug="FP"
        type="checkbox"
        onChange={() => changeWord('FP')}
      />
      <label className="ac-label" htmlFor="ac-3afd">{label}</label>
      <article className="ac-text ac-3afd">
        <div className="single-post-interior" tabIndex="0">
          <table>
            <tbody>
              <tr>
                <td>{verifiedLabel}</td>
                <td>{vFP}FP</td>
              </tr>
              <tr>
                <td>{statedLabel}</td>
                <td>{sFP}FP</td>
              </tr>
            </tbody>
          </table>
          <FPContent t={t} o={o} />
          <footer></footer>
        </div>
      </article>
    </div>
  );
}

export default FillPower;
